import { Routes } from '@angular/router';

export const PLAYGROUND_ROUTES: Routes = [
  {
    path: 'playground',
    loadComponent: () =>
      import('./pages/playground/playground.component').then((m) => m.PlaygroundComponent),
  },
  {
    path: 'playground/callback',
    loadComponent: () =>
      import('./pages/callback/callback.component').then((m) => m.PlaygroundCallbackComponent),
  },
];
